
import get from "lodash-es/get";
import set from "lodash-es/set";
import filter from "lodash-es/filter";

import "es6-promise";

import axios, { AxiosResponse } from "axios";
import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch,
} from "vue-property-decorator";

import { sha1 } from "object-hash";

import { Sample, SampleCartItems } from "../model";

import { DummySampleList as _dummySampleList } from "../test-data";

@Component({
  filters: {},
})
export default class SampleTable extends Vue {
  // public samples: Array<Sample> = _dummySampleList;

  @Prop({ default: {}, type: Object })
  public samples: SampleCartItems;

  ////
  // fields and editableFields can be either top level properties of
  // Sample (eg name, id) or properties of metadata (eg metadata.condition),
  // specified via dot notation: metadata.condition

  // = ["name", "metadata.condition", "R1", "R2"];
  @Prop({ default: () => [], type: Array })
  public fields: Array<string>;

  // = ["name", "metadata.condition"];
  @Prop({ default: () => [], type: Array })
  public editableFields: Array<string>;
  ////

  @Prop({ default: true, type: Boolean })
  public selectable: boolean;

  public selectedSamples: Array<Sample> = [];

  // lodash & object-hash for templates
  get = get;
  filter = filter;
  sha1 = sha1;

  /* Sets/retrieves a property deeply.nested.in.an.object */
  deep_path(obj: any, path: string): any {
    return get(obj, path);
  }

  onSelect(rows: any) {
    this.selectedSamples = rows as Array<Sample>;
    this.$emit("selected", this.selectedSamples);
  }

  onChangeField(sample: Sample, field_path: string, newValue: string) {
    set(sample, field_path, newValue);
  }

  removeSelected() {
    for (const row of this.selectedSamples) {
      const i = this.samples.items.indexOf(row);
      this.samples.items.splice(i, 1);
    }
  }
}
